<template>
    <div class="modal fade" :id="id" tabindex="-1">
      <div class="modal-dialog modal-md">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('projects.add_files') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
            <div class="modal-body">
              <RequiredText />
              <DropFileZone
                :id="`${id}_upload_file`"
                :files="formData.files"
                @addFiles="addFiles"
                @removeFiles="removeFiles" 
              />
              <TagifyInput
                containerClass="col-12 mt-5 mb-5"
                type="text"
                :label="$t('projects.label.keywords')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="false" size="lg"
                v-model="formData.key_word"
                :parent-id="'#'+id"
                :name="`${id}-keyword`"
                :helper-text="$t('attributes.tag_input_text')"
                :placeholder="$t('projects.keyword_text')"
              />
              <SwitchInput id="customer_can_view" :label="$t('projects.canCustomerHaveAccess')" v-model="formData.customer_can_view"/>

            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script setup>
    import {ref, defineEmits, defineProps, computed, onMounted} from "vue";
    import {useStore} from "vuex";
    import Button from "@/components/Button.vue"
    import RequiredText from "@/components/RequiredText.vue";
    import Select2 from "@/components/Select2.vue";
    import DropFileZone from "@/components/DropFileZone.vue";
    import TagifyInput from "@/components/TagifyInput.vue";
import SwitchInput from "@/components/SwitchInput.vue";

    const store = useStore()
    
    const emits = defineEmits(['load'])
    const props = defineProps({
        id: {
          type: String,
          required: true
        },
        form: {
          type: Object,
          default: {
            project_folder_id: '',
            files: [],
            key_word: [],
            customer_can_view: false
          }
        },
        folder: {
          type: String,
          required: true
        },
    })

    const isLoading = ref(false)
    const formData = ref(props.form)
  
    function closeModal(){
        $('#'+props.id).modal('toggle')
    }

    function addFiles(files){
      for(let file of files) {
        formData.value.files.push(file)
      }
    }

    function removeFiles(index) {
      formData.value.files.splice(index, 1)
    }

    function submitForm(){
      isLoading.value = true
      formData.value.project_folder_id = props.folder
      store.dispatch('projects/createDirectoryFile', formData.value)
            .then((response) => {
                isLoading.value = false
                emits('load')
                closeModal()
                formData.value={
                  project_folder_id: '',
                  files: [],
                  key_word: [],
                  customer_can_view: false
                }
                window.toastr['success'](i18n.global.t('projects.file_added_successfully'))
            })
            .catch(err => {
                isLoading.value = false
            })
    }
</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>